module.exports = __webpack_public_path__ + "static/story6-menu-thumbnails-400x400-62e0b2c09f9c3eed223b6a7e6e714250.jpg";